import { env } from "@/lib/env";

export function startOidcLogin(): void {
  // Redirect direto para o backend, que sabe o provider OIDC.
  const url = new URL("/auth/sso/login", env.API_BASE_URL);
  url.searchParams.set("redirect_uri", `${window.location.origin}/auth/callback`);
  window.location.assign(url.toString());
}
